import type { Translations } from './en';
const appName = process.env.NEXT_PUBLIC_APP_NAME || 'MyApp';
const id: Translations = {
  common: {
    appName: appName,
    loading: 'Memuat...',
    save: 'Simpan',
    cancel: 'Batal',
    confirm: 'Konfirmasi',
    delete: 'Hapus',
    edit: 'Edit',
    back: 'Kembali',
    search: 'Cari',
    noResults: 'Tidak ada hasil ditemukan',
    error: 'Terjadi kesalahan',
    success: 'Berhasil',
  },
  header: {
    searchPlaceholder: 'Cari coser, hotgirl, ao dai, model...',
    searchPlaceholderMobile: 'Cari...',
    home: 'Beranda',
    hotgirl: 'Hotgirl',
    coser: 'Coser',
    model: 'Model',
    upload: 'Unggah',
    notifications: 'Notifikasi',
    login: 'Masuk',
    register: 'Daftar',
  },
  footer: {
    tagline: `Platform terbaik untuk berbagi foto Coser, Hotgirl, dan Model di ${appName}.`,
    copyright: `© {year} ${appName}. Seluruh hak cipta dilindungi.`,
    sections: {
      explore: 'Jelajahi',
      account: 'Akun',
      support: 'Dukungan',
    },
    links: {
      home: 'Beranda',
      hotgirl: 'Hotgirl',
      coser: 'Coser',
      model: 'Model',
      aoDai: 'Ao Dai',
      login: 'Masuk',
      register: 'Daftar',
      upload: 'Unggah Foto',
      dashboard: 'Dasbor',
      terms: 'Syarat Layanan',
      privacy: 'Kebijakan Privasi',
      report: 'Laporkan Pelanggaran',
      contact: 'Hubungi Kami',
    },
  },
  collections: {
    title: 'Koleksi',
    createAlbum: 'Buat Album',
    saved: 'Tersimpan',
    noSaved: 'Belum ada foto tersimpan',
    noSavedHint: 'Jelajahi foto sekarang →',
    removedSave: 'Dihapus dari simpanan',
    createModalTitle: 'Buat album baru',
    albumNamePlaceholder: 'Nama album...',
    cancel: 'Batal',
    create: 'Buat',
    albumCreated: 'Album dibuat',
  },
  home: {
    title: 'Temukan',
    titleHighlight: 'keindahan',
    titleSuffix: 'kehidupan',
    subtitle: 'Ribuan foto Coser, Hotgirl, dan Model diperbarui setiap hari',
    sortNewest: 'Terbaru',
    sortTrending: 'Trending',
    sortPopular: 'Populer',
    allCategories: 'Semua',
    noMorePosts: 'Anda telah melihat semua foto',
  },
  auth: {
    login: {
      title: 'Masuk untuk melanjutkan',
      continueWithGoogle: 'Lanjutkan dengan Google',
      orLoginWithEmail: 'atau masuk dengan email',
      email: 'Email',
      password: 'Kata sandi',
      forgotPassword: 'Lupa kata sandi?',
      submitButton: 'Masuk',
      loading: 'Sedang masuk...',
      noAccount: 'Belum punya akun?',
      registerLink: 'Daftar sekarang',
      errorCredentials: 'Email atau kata sandi salah',
      successLogin: 'Berhasil masuk!',
    },
    register: {
      title: 'Buat akun gratis',
      displayName: 'Nama Tampilan',
      displayNamePlaceholder: 'Budi Santoso',
      email: 'Email',
      password: 'Kata sandi',
      passwordPlaceholder: 'Minimal 8 karakter',
      confirmPassword: 'Konfirmasi Kata Sandi',
      submitButton: 'Daftar',
      loading: 'Membuat akun...',
      hasAccount: 'Sudah punya akun?',
      loginLink: 'Masuk',
      errorPasswordMismatch: 'Kata sandi tidak cocok',
      errorPasswordLength: 'Kata sandi minimal 8 karakter',
      errorGeneric: 'Pendaftaran gagal',
      successRegister: 'Akun berhasil dibuat!',
      emailTaken: 'Email sudah digunakan',
      serverError: 'Kesalahan server, coba lagi nanti',
    },
    forgotPassword: {
      title: 'Lupa kata sandi',
      subtitle: 'Masukkan email Anda dan kami akan mengirim tautan reset',
      email: 'Email',
      submitButton: 'Kirim Tautan Reset',
      backToLogin: 'Kembali ke masuk',
      sending: 'Mengirim...',
      emailSent: 'Email terkirim!',
      checkEmail: 'Periksa kotak masuk {email} untuk tautan reset kata sandi.',
      instructions: 'Masukkan email Anda dan kami akan mengirim tautan untuk mereset kata sandi.',
    },
  },
  userMenu: {
    dashboard: 'Dasbor',
    collections: 'Koleksi',
    settings: 'Pengaturan',
    logout: 'Keluar',
  },
  settings: {
    title: 'Pengaturan Akun',
    profile: {
      nav: 'Profil',
      title: 'Informasi Profil',
      displayName: 'Nama Tampilan',
      username: 'Nama Pengguna',
      website: 'Situs Web',
      bio: 'Bio',
      bioPlaceholder: 'Perkenalkan diri Anda...',
      changeAvatar: 'Ganti Avatar',
      avatarHint: 'JPG, PNG, WebP maks 5MB',
      saveButton: 'Simpan Perubahan',
      saving: 'Menyimpan...',
      savedSuccess: 'Perubahan tersimpan',
    },
    password: {
      nav: 'Kata Sandi',
      title: 'Ganti Kata Sandi',
      fields: {
        currentPassword: 'Kata Sandi Saat Ini',
        newPassword: 'Kata Sandi Baru',
        confirm: 'Konfirmasi Kata Sandi Baru',
      },
      errors: {
        confirm: 'Kata sandi baru tidak cocok',
        minLength: 'Kata sandi minimal 8 karakter',
      },
      success: 'Kata sandi berhasil diubah!',
      saving: 'Menyimpan...',
      submit: 'Ganti Kata Sandi',
    },
    notifications: {
      nav: 'Notifikasi',
      title: 'Pengaturan Notifikasi',
      options: {
        likes: 'Ketika seseorang menyukai foto Anda',
        comments: 'Ketika seseorang berkomentar',
        replies: 'Ketika seseorang membalas komentar Anda',
        follows: 'Ketika seseorang mengikuti Anda',
        approved: 'Ketika postingan disetujui',
        email_digest: 'Ringkasan email mingguan',
        marketing: 'Notifikasi promosi dan acara',
      },
      saveSuccess: 'Pengaturan notifikasi tersimpan',
      saving: 'Menyimpan...',
      saveButton: 'Simpan Pengaturan',
    },
    security: {
      nav: 'Keamanan',
      twoFactorAuth: 'Autentikasi Dua Faktor (2FA)',
      twoFactorAuthHint: 'Tingkatkan keamanan dengan kode verifikasi dari aplikasi',
      comingSoon: 'Segera Hadir',
      activeSessions: 'Sesi Aktif',
      currentBrowser: 'Browser Saat Ini',
      lastLogin: 'Login Terakhir',
      active: 'Aktif',
      dangerZone: 'Zona Berbahaya',
      deleteAccountHint: 'Menghapus akun akan menghapus semua data Anda secara permanen.',
      deleteAccount: 'Hapus Akun',
    },
  },
  post: {
    likes: '{count} suka',
    views: '{count} tampilan',
    shares: '{count} bagikan',
    comments: '{count} komentar',
    save: 'Simpan',
    saved: 'Tersimpan',
    share: 'Bagikan',
    linkCopied: 'Tautan disalin!',
    follow: 'Ikuti',
    following: 'Mengikuti',
    relatedPosts: 'Postingan Terkait',
    commentPlaceholder: 'Tulis komentar...',
    commentLoginPlaceholder: 'Masuk untuk berkomentar...',
    commentSubmit: 'Kirim',
    commentSubmitting: 'Mengirim...',
    noComments: 'Belum ada komentar. Jadilah yang pertama!',
    savedToCollection: 'Disimpan ke koleksi',
    removedFromCollection: 'Dihapus dari koleksi',
    description: 'Deskripsi',
    profileView: 'Lihat profil',
  },
  notifications: {
    title: 'Notifikasi',
    empty: 'Tidak ada notifikasi',
    markAllRead: 'Tandai semua sudah dibaca',
    types: {
      like_post: 'menyukai foto Anda',
      comment: 'mengomentari foto Anda',
      reply: 'membalas komentar Anda',
      follow: 'mengikuti Anda',
      approve: 'postingan Anda disetujui',
      reject: 'postingan Anda ditolak',
      system: 'notifikasi sistem',
    },
  },
  search: {
    title: 'Hasil pencarian untuk',
    result: 'Hasil',
    tryOtherKeywords: 'Coba kata kunci lain...',
    noResults: 'Tidak ada hasil untuk',
    placeholder: 'Cari...',
    thisHashtag: 'foto dengan hashtag ini',
  },
  upload: {
    title: 'Unggah Foto',
    dragDrop: 'Seret & lepas atau klik untuk memilih',
    supportedFormats: 'Mendukung JPG, PNG, WebP, GIF',
    submit: 'Terbitkan',
    submitting: 'Menerbitkan...',
    titleField: 'Judul',
    titlePlaceholder: 'Masukkan judul yang menarik...',
    descriptionField: 'Deskripsi',
    descriptionPlaceholder: 'Deskripsi lengkap set foto...',
    hashtagsField: 'Hashtag',
    statusField: 'Status',
    statusPublic: 'Publik',
    statusPrivate: 'Privat',
    statusDraft: 'Draf',
    error: 'Gagal mengunggah',
    errorSelect: 'Pilih minimal 1 foto',
    errorTitle: 'Masukkan judul',
    photos: 'foto',
    uploading: 'Mengunggah...',
  },
  notFound: {
    title: 'Halaman tidak ditemukan',
    subtitle: 'Halaman yang Anda cari tidak ada.',
    backHome: 'Kembali ke Beranda',
  },
  liked: {
    title: 'Postingan yang Disukai',
    empty: 'Anda belum menyukai postingan apapun.',
  },
  user: {
    unknown: 'Tidak dikenal',
  },
  globalError: {
    title: 'Terjadi kesalahan',
    subtitle: 'Maaf atas ketidaknyamanannya. Silakan coba lagi.',
    retry: 'Coba Lagi',
  },
  username: {
    posts: 'Postingan',
    likes: 'Suka',
    followers: 'Pengikut',
    following: 'Mengikuti',
    editProfile: 'Edit Profil',
    message: 'Pesan',
    noPosts: 'Belum ada postingan.',
    bio: 'Lihat foto ',
    notFound: 'Pengguna tidak ditemukan',
  },
  topic: {
    notFound: 'Topik tidak ditemukan',
    viewTitle: 'Lihat topik ',
  },
  dashboard: {
    title: 'Dasbor',
    welcome: 'Halo',
    stats: {
      posts: 'Postingan',
      views: 'Tampilan',
      likes: 'Suka',
      comments: 'Komentar',
    },
  },
  adsblock: {
    title: 'Anda menggunakan AdBlock',
    description: 'Nonaktifkan AdBlock untuk melihat gambar berkualitas tinggi dan membantu kami menjaga situs tetap gratis.',
    action: 'Saya sudah menonaktifkan — Muat Ulang',
    cancel: 'Lewati',
  },
  pwa: {
    title: `Instal ${appName} untuk pengalaman yang lebih baik!`,
    iosSubtitle: `Tekan Bagikan → Tambahkan ke Layar Utama`,
    androidSubtitle: `Dapatkan pemberitahuan tentang set foto baru segera setelah dirilis`,
    installButton: `Instal ${appName}`,
    disclaimer: `Instalasi cepat, tidak perlu toko aplikasi.`,
  },
  autotrans: {
    title: 'Diterjemahkan secara otomatis',
    translated: 'Terjemahan',
    origin: 'Konten Asli',
  },
  subscription: {
    title: 'Berlangganan Notifikasi',
    description: 'Dapatkan pemberitahuan tentang set foto baru segera setelah dirilis.',
    subscribeButton: 'Berlangganan',
    unsubscribeButton: 'Berhenti Berlangganan',
    subscribed: 'Anda telah berlangganan notifikasi.',
    unsubscribed: 'Anda telah berhenti berlangganan notifikasi.',
    error: 'Terjadi kesalahan saat memperbarui langganan Anda. Silakan coba lagi.',
    success_tit: '🎉 Notifikasi Diaktifkan!',
    denied_tit: 'Notifikasi Ditolak',
    error_tit: 'Terjadi Kesalahan',
    success_des: 'Anda akan menerima notifikasi saat konten baru tersedia.',
    denied_des: 'Anda dapat mengaktifkannya kembali di pengaturan browser Anda.',
    error_des: 'Silakan coba lagi nanti.',
    skip: 'Lewati',
    processing: 'Memproses...',
    noti: 'Aktifkan Notifikasi',
    rule: 'Hanya tampilkan notifikasi untuk konten baru.',
    notify_title: `Notifikasi - ${appName}`,
    notify_body: "Galeri baru telah dirilis. Cek sekarang!",
  },
  contact: {
    title: 'Hubungi Kami',
    subtitle: 'Kami ingin mendengar dari Anda! Silakan isi formulir di bawah ini dan kami akan menghubungi Anda sesegera mungkin.',
    name: 'Nama',
    email: 'Email',
    subject: 'Subjek',
    message: 'Pesan',
    submitButton: 'Kirim Pesan',
    sending: 'Mengirim...',
    successTitle: 'Pesan Terkirim!',
    successMessage: 'Terima kasih telah menghubungi kami. Kami akan segera menghubungi Anda.',
    errorTitle: 'Terjadi kesalahan',
    errorMessage: 'Terjadi kesalahan saat mengirim pesan Anda. Silakan coba lagi nanti.',
    res_time_title: 'Waktu respons',
    res_time: 'Kami biasanya merespons dalam 1–3 hari kerja.',
    report_content: 'Laporkan Konten',
    report_content_hint: 'Untuk melaporkan pos atau pengguna, gunakan tombol lapor langsung di konten atau pilih &ldquo;Laporkan konten&rdquo; di atas.',
    value_default: 'Pilih topik',
    value_general: 'Pertanyaan umum',
    value_report: 'Laporkan konten',
    value_account: 'Masalah akun',
    value_business: 'Bisnis / kemitraan',
    value_feedback: 'Umpan balik & saran',
    value_other: 'Lainnya'
  },
  language: {
    label: 'Bahasa',
    en: 'English',
    vi: 'Tiếng Việt',
    zh: '中文',
    ja: '日本語',
    ko: '한국어',
    ar: 'العربية',
    fr: 'Français',
    es: 'Español',
    ru: 'Русский',
    hi: 'हिन्दी',
    id: 'Indonesia',
    de: 'Deutsch',
    pt: 'Português',
    it: 'Italiano',
  },
} as const;

export default id;